import React, {useCallback, useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import {insert_at} from "../../../common";
import {useModelContext} from "../../../context/ModelContextProvider";
import {MOBILE_WIDTH, useLogout, useResize} from "../../../utils/Hooks";
import {cache_actions} from "../../../redux/slice/CacheReducer";
import {account_actions} from "../../../redux/slice/AccountReducer";
import styled from "@emotion/styled";
import {useTheme} from "@emotion/react";
import {useDialogContext} from "../../../context/DialogContextProvider";
import {lang} from "../../../lang";

// @TODO is_interactive 사용 안하고 있음
export const createContextMenuView = ({content, props, is_interactive = true}) => {
    return (
        <div
            {...props}
            style={{
                ...props.style,
                ...(!is_interactive && {pointerEvents: "none"}),
            }}>
            {content}
        </div>
    );
};

export const createContextMenu = (content, onClick) => {
    return {
        content,
        props: {
            onClick: onClick,
        },
    };
};

const ContextMenu = (props) => {
    // Dialog Context
    const dialog_props = props.dialog_props || {};
    const dialog_utils = props.dialog_utils || {};

    const dispatch = useDispatch();
    const {account_model} = useModelContext();
    const account_reducer = useSelector((state) => state.account_reducer);
    const location = useLocation();
    const {doLogout} = useLogout();

    // state
    const [right, setRight] = useState(null);
    const [top, setTop] = useState(null);
    const [is_mobile, setMobile] = useState(false);

    // ref
    const hide_worker = useRef(null);
    const change_location_count = useRef(0);

    // css style
    const {view} = useComponentStyle();

    useResize((width) => {
        const body_points = window.document.body.getBoundingClientRect();
        const anchor_points = props.anchor_view?.getBoundingClientRect() || {
            bottom: 0,
            height: 0,
            left: 0,
            right: 0,
            top: 0,
            width: 0,
            x: 0,
            y: 0,
        };
        setTop(anchor_points.height);
        setRight(body_points.width - anchor_points.right);
        setMobile(width < MOBILE_WIDTH);
    }, []);

    const createContextMenus = (header_menus) => {
        let views = [];
        if (Array.isArray(header_menus)) {
            for (let header_menu of header_menus) {
                let view = null;
                if (header_menu) {
                    try {
                        view = createContextMenuView(header_menu);
                    } catch (e) {}
                }

                if (view !== null) {
                    views.push(view);
                }
            }
        }

        // 내 정보 수정
        insert_at(
            views,
            0,
            createContextMenuView({
                is_interactive: true,
                content: "내 정보 수정",
                props: {
                    onClick: () => {
                        dialog_utils.moveTo({url: "/account/update-info"});
                    },
                },
            })
        );

        // 마지막에 로그아웃 버튼 추가
        views.push(
            createContextMenuView({
                is_interactive: true,
                content: "로그아웃",
                props: {
                    onClick: () => {
                        dialog_utils.hideAndTask(dialog_props.id, doLogout);
                    },
                },
            })
        );

        return views.map((view, index) => {
            return (
                <li className="header-context-menu-item" key={index}>
                    {view}
                </li>
            );
        });
    };

    const hide = useCallback(() => {
        clearTimeout(hide_worker.current);
        props.dialog_utils.hideDialog && props.dialog_utils.hideDialog(props.dialog_props.id);
    }, [props.dialog_props.id, props.dialog_utils]);

    const requestHide = useCallback(
        (duration) => {
            clearTimeout(hide_worker.current);
            hide_worker.current = setTimeout(() => {
                hide();
            }, duration || 0);
        },
        [hide]
    );

    useEffect(() => {
        requestHide(1000 * 3);
        return () => {
            clearTimeout(hide_worker.current);
        };
    }, [requestHide]);

    useEffect(() => {
        if (change_location_count.current > 0) {
            hide();
        }
        change_location_count.current++;
    }, [location, hide]);

    return (
        <>
            <view.ContextMenuWrapper
                className="header-context-menu-container"
                onClick={(event) => {
                    if (event.target.className === "header-context-menu-container") {
                        hide();
                    }
                }}>
                <view.ContextUl
                    className="header-context-menu-content"
                    onMouseEnter={() => {
                        clearTimeout(hide_worker.current);
                    }}
                    onMouseLeave={() => {
                        requestHide();
                    }}
                    style={!is_mobile ? {right: `${right}px`, top: `${top + 1}px`} : null}>
                    {createContextMenus(props.menus)}
                </view.ContextUl>
            </view.ContextMenuWrapper>
        </>
    );
};

export default ContextMenu;

export const useComponentStyle = () => {
    const theme = useTheme();
    return {
        view: {
            ContextMenuWrapper: styled.div({
                position: "absolute",
                width: "100%",
                height: "100%",
                bottom: "0",
                top: "0",
                zIndex: "6000",
            }),
            ContextUl: styled.ul({
                position: "fixed",
                width: "10%",
                minWidth: "6.5em",
                height: "auto",
                boxSizing: "border-box",
                border: "1px solid " + theme.colors.lg2,
                background: theme.colors.w,
                boxShadow: theme.box_shadow,
                li: {
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    div: {
                        padding: ".5em 1em",
                        fontSize: ".9em",
                        "&:hover": {
                            backgroundColor: theme.colors.context_hover,
                        },
                    },
                },
            }),
        },
    };
};
